import Vue from "vue";
import Vuex from "vuex";
import VueAxios from "vue-axios";
import { VueAuthenticate } from "vue-authenticate";
import axios from "axios";
import moment from "moment";
import axiosclient from "../../utils/axiosclient";
Vue.use(Vuex);
Vue.use(VueAxios, axios);

const ENDPOINT_TASKS = "/v2/tasks";
//const ENDPOINT_TASKS_BY_PROJECT_ID= "/projects/:id/tasks"
const ENDPOINT_TASK_TYPES = "/v1/task-types";
const ENDPOINT_TASK_DETAILS = "/v2/tasks/:id/comments";

const state = {
  tasks: null,
  taskTypes: null,
  task: null,
  singleTask: null
};

const getters = {};

const mutations = {
  setTasks: (state, payload) => {
    state.tasks = payload;
  },

  setTask: (state, payload) => {
    state.task = payload;
  },

  setSingleTask: (state, payload) => {
    state.singleTask = payload;
  },

  setTaskTypes: (state, payload) => {
    state.taskTypes = payload;
  }
};

const actions = {
  createTask({ commit, rootState }, payload) {
    commit("setLoading", true, { root: true });
    return axiosclient
      .post('/v2/tasks', payload)
      .then(res => {
        commit("setLoading", false, { root: true });
        return Promise.resolve(res.data);
      })
      .catch(err => {
        commit("setLoading", false, { root: true });
        return Promise.reject(err);
      });
  },

  updateTask({ commit, rootState }, payload) {
    commit("setLoading", true, { root: true });
    return axiosclient
      .put("/v2/tasks/" + payload.id, payload)
      .then(res => {
        commit("setLoading", false, { root: true });
        return Promise.resolve(res.data);
      })
      .catch(err => {
        commit("setLoading", false, { root: true });
        return Promise.reject(err);
      });
  },

  deleteTask({ commit, rootState }, payload) {
    //commit("setLoading", true, { root: true });
    return axiosclient
      .delete("/v2/tasks/" + payload.id)
      .then(res => {
        //commit("setLoading", false, { root: true });
        return Promise.resolve(res.data);
      })
      .catch(err => {
        //commit("setLoading", false, { root: true });
        return Promise.reject(err);
      });
  },

  updateTaskStatus({ commit, rootState }, payload) {
    //commit('setLoading', true, {root: true})
    return axiosclient
      .put(ENDPOINT_TASKS + "/" + payload.id + "/change-status", payload)
      .then(res => {
        //commit('setLoading', false, {root: true})
        return Promise.resolve(true);
      })
      .catch(err => {
        //commit('setLoading', false, {root: true})
        return Promise.reject(false);
      });
  },

  //depreciated
  fetchAllTasks({ commit }, payload) {
    commit("setLoading", true, { root: true });
    return axiosclient
      .get(ENDPOINT_TASKS)
      .then(({ data }) => {
        let tasks = data.sort((a, b) => {
          return moment(a.start_date).diff(moment(b.start_date))
      }).map(r => {
          r.assigned_to_client = r.project.user_admin;
          r.assigned_by_client = r.project.user_admin; //@sushil need to send user_owner obj also
          //console.log(moment(r.start_date).format('DD-MM-YYYY'));
          let sd = (r.start_date && moment(r.start_date)) || moment();
          r.start_date = sd.format("DD-MM-YYYY");
          //console.log(r.start_date);

          r.finance = 100;
          r.status = (!r.status || r.status == "")? "OPEN":r.status
          if(r.total_team_members == 0) r.total_team_members = 1
          if(r.mbs_months < 2 || r.mbs_months == null) r.mbs_months = 1
          //r.color="grey"
          r.showBilling = r.finance || false;
          if (r.end_date) {
            let ed = moment(r.end_date);
            r.end_date = ed.format("DD-MM-YYYY");
            r.duration = ed.diff(sd, "days");
          } else {
            r.duration = 1;
          }
          
          //console.log(r.start_date, r.end_date);
          return r;
        });
        // commit("setLoading", false, { root: true });
        commit("setTasks", { data: tasks });
        return Promise.resolve(true);
      })
      .catch(err => {
        console.log(err);
        commit("setLoading", false, { root: true });
        return Promise.reject(false);
      });
  },
  
  //current
  fetchAllTasksByProjectId({ commit }, payload, showLoader = true) {
    
    return axiosclient
      .get("/v2/tasks-by-project/" + payload)
      .then(({ data }) => {
        let tasks = data.data.tasks.map(r => {
          if(r.assignedBy)
            r.assigned_by_client = r.assignedBy
          r.assigned_to_client = []
          if (r.assignedTo) {
            r.assigned_to_client = [r.assignedTo]; //@sushil need to send user_owner obj also
          }

          r.readonly = r.permission && r.permission.edit == 0

          if(r.total_team_members == 0) r.total_team_members = 1
          if(r.mbs_months < 2 || r.mbs_months == null) r.mbs_months = 1

          // if (r.cc) {
          //   r.assigned_to_client = [...r.assigned_to_client, ...r.cc]; //@sushil need to send user_owner obj also
          // }

          //console.log(moment(r.start_date).format('DD-MM-YYYY'));
          let sd = (r.start_date && moment(r.start_date)) || moment();
          r.start_date = sd.format("DD-MM-YYYY 00:00:00");
          //console.log(r.start_date);
          r.status = (!r.status || r.status == "")? "OPEN":r.status
          if(r.status == "CLOSED") {
            r.color = "gray"
          }

          if(r.discount_percentage == 0) {
            r.discount_percentage = 'N/A'
          }
          
          if (r.end_date) {
            let ed = moment(r.end_date);
            r.end_date = ed.format("DD-MM-YYYY 23:59:00");
            // r.ed = ed.format("DD-MM-YYYY 23:59:00")
            r.duration = ed.diff(sd, "days");
          } else {
            r.duration = 1;
          }
          //console.log(r.start_date, r.end_date);
          return r;
        });
        commit("setLoading", false, { root: true });
        commit("setTasks", { data: tasks });
        return Promise.resolve(true);
      })
      .catch(err => {
        console.log(err);
        commit("setLoading", false, { root: true });
        return Promise.reject(false);
      });
  },

  filterTasks({ commit }, payload, showLoader = true) {
    
    return axiosclient
      .get("/v1/filter-tasks/",{params: payload})
      .then(({ data }) => {
        let tasks = data.data.tasks.map(r => {
          if(r.assignedBy)
            r.assigned_by_client = r.assignedBy
          r.assigned_to_client = []
          if (r.assignedTo) {
            r.assigned_to_client = [r.assignedTo]; //@sushil need to send user_owner obj also
          }

          r.readonly = r.permission && r.permission.edit == 0
          if(r.total_team_members == 0) r.total_team_members = 1
          if(r.mbs_months < 2 || r.mbs_months == null) r.mbs_months = '-'
          // if (r.cc) {
          //   r.assigned_to_client = [...r.assigned_to_client, ...r.cc]; //@sushil need to send user_owner obj also
          // }

          //console.log(moment(r.start_date).format('DD-MM-YYYY'));
          let sd = (r.start_date && moment(r.start_date)) || moment();
          r.start_date = sd.format("DD-MM-YYYY 00:00:00");
          //console.log(r.start_date);
          r.status = (!r.status || r.status == "")? "OPEN":r.status
          if(r.status == "CLOSED") {
            r.color = "gray"
          }

          if(r.discount_percentage == 0) {
            r.discount_percentage = 'N/A'
          }
          
          if (r.end_date) {
            let ed = moment(r.end_date);
            r.end_date = ed.format("DD-MM-YYYY 23:59:00");
            // r.ed = ed.format("DD-MM-YYYY 23:59:00")
            r.duration = ed.diff(sd, "days");
          } else {
            r.duration = 1;
          }
          //console.log(r.start_date, r.end_date);
          return r;
        });
        commit("setLoading", false, { root: true });
        commit("setTasks", { data: tasks });
        return Promise.resolve(true);
      })
      .catch(err => {
        console.log(err);
        commit("setLoading", false, { root: true });
        return Promise.reject(false);
      });
  },

  fetchAllTimelineTasksByProjectId({ commit }, payload, showLoader = true) {
    
    return axiosclient
      .get("/v1/timeline-tasks-by-project/" + payload)
      .then(({ data }) => {
        let tasks = data.data.tasks.map(r => {
          if(r.assignedBy)
            r.assigned_by_client = r.assignedBy
          r.assigned_to_client = []
          if (r.assignedTo) {
            r.assigned_to_client = [r.assignedTo]; //@sushil need to send user_owner obj also
          }

          //r.readonly = r.permission && r.permission.edit == 0

          // if (r.cc) {
          //   r.assigned_to_client = [...r.assigned_to_client, ...r.cc]; //@sushil need to send user_owner obj also
          // }

          //console.log(moment(r.start_date).format('DD-MM-YYYY'));
          let sd = (r.start_date && moment(r.start_date)) || moment();


          r.start_date = {
            year: sd.year(),
            month: sd.month()+1,
            day: sd.day(),
            hour: sd.hour(),
            minute: sd.minute(),
            second: sd.second(),
          }
          //console.log(r.start_date);
          r.status = (!r.status || r.status == "")? "OPEN":r.status
          // if(r.status == "CLOSED") {
          //   r.background = {color:"gray"}
          // } else {
          //   r.background = {color:"blue"}
          // }

          if(r.discount_percentage == 0) {
            r.discount_percentage = 'N/A'
          }
          
          if (r.end_date) {
            let ed = moment(r.end_date);
            r.end_date = {
              year: ed.year(),
              month: ed.month()+1,
              day: ed.day(),
              hour: ed.hour(),
              minute: ed.minute(),
              second: ed.second(),
            }
            
          } else {
            r.duration = 1;
          }
          r.text = {headline: r.name, text: (r.last_comment || {description:''}).description }
          //console.log(r.start_date, r.end_date);
          return r;
        });
        commit("setLoading", false, { root: true });
        
        return Promise.resolve(tasks);
      })
      .catch(err => {
        console.log(err);
        commit("setLoading", false, { root: true });
        return Promise.reject(err);
      });
  },

  fetchAllTaskTypes({ commit }, payload) {
    return axiosclient
      .get(ENDPOINT_TASK_TYPES)
      .then(res => {
        commit("setTaskTypes", res.data);
        return Promise.resolve(res.data);
      })
      .catch(err => {
        console.log(err);
        return Promise.reject(err);
      });
  },

  fetchSingleTask({ commit }, {val,refresh = true}) {
    if(refresh) 
      commit("setLoading", true, { root: true });

    return axiosclient
      .get("/v2/tasks/" + val)
      .then(res => {
        commit("setSingleTask", res.data);
        commit("setLoading", false, { root: true });
        return Promise.resolve(res.data);
      })
      .catch(err => {
        console.log(err);
        commit("setLoading", false, { root: true });
        return Promise.reject(err);
      });
  },

  searchTask({ commit }, payload) {
    

    commit("setLoading", true, { root: true });
    return axiosclient
      .get("/v2/search-tasks-for-project/" + payload.id + "/search", {params: payload})
      .then(({ data }) => {
        let tasks = data.data.tasks.map(r => {
          if(r.assignedBy)
            r.assigned_by_client = r.assignedBy
          r.assigned_to_client = []
          if (r.assignedTo) {
            r.assigned_to_client = [r.assignedTo]; //@sushil need to send user_owner obj also
          }

          if (r.cc) {
            r.assigned_to_client = [...r.assigned_to_client, ...r.cc]; //@sushil need to send user_owner obj also
          }

          //console.log(moment(r.start_date).format('DD-MM-YYYY'));
          let sd = (r.start_date && moment(r.start_date)) || moment();
          r.start_date = sd.format("DD-MM-YYYY 00:00:00");
          //console.log(r.start_date);

          r.finance = 100;
          r.showBilling = r.finance || false;
          if (r.end_date) {
            let ed = moment(r.end_date);
            r.end_date = ed.format("DD-MM-YYYY 23:59:00");
            // r.ed = ed.format("DD-MM-YYYY 23:59:00")
            r.duration = ed.diff(sd, "days");
          } else {
            r.duration = 1;
          }
          //console.log(r.start_date, r.end_date);
          return r;
        });
        commit("setLoading", false, { root: true });
        //commit("setTasks", { data: tasks });
        return Promise.resolve({ data: tasks });
      })
      .catch(err => {
        console.log(err);
        commit("setLoading", false, { root: true });
        return Promise.reject(err);
      });
  },

  fetchTaskDetails({ commit }, payload) {
    return axiosclient
      .get(ENDPOINT_TASK_DETAILS.replace(":id", payload))
      .then(res => {
        commit("setTask", res.data.data);
        return Promise.resolve(res.data.data);
      })
      .catch(err => {
        console.log(err);
        return Promise.reject(err);
      });
  },

  saveTaskComment({ commit }, payload) {
    commit("setLoading", true, { root: true });
    return axiosclient
      .post("/v2/tasks/:id/comment".replace(":id", payload.taskId), payload)
      .then(res => {
        commit("setLoading", false, { root: true });
        return Promise.resolve(res.data.data);
      })
      .catch(err => {
        console.log(err);
        commit("setLoading", false, { root: true });
        return Promise.reject(err);
      });
  },

  createAssetThread({ commit, rootState }, payload) {
    //commit("setLoading", true, { root: true });
    return axiosclient
      .post('/v2/assets/thread', payload)
      .then(res => {
        //commit("setLoading", false, { root: true });
        return Promise.resolve(res.data);
      })
      .catch(err => {
        //commit("setLoading", false, { root: true });
        return Promise.reject(err);
      });
  }
};



export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
